import React, { useRef, type FC } from 'react'

import { useIntl } from 'react-intl'

import {
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputText,
} from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { changeCriterionCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'
import { criterionAnagraphicFieldState } from 'Pages/RecipientsList/recoil/state/filters'

interface InputValueProps {
  index: number
}

const InputValues: FC<InputValueProps> = ({ index }) => {
  const intl = useIntl()
  const dirty = useRef(false)

  const item = useRecoilValue(criterionAnagraphicFieldState(index))

  const changeCriterion = useRecoilCallback(changeCriterionCallback, [])

  const handleChange = ({
    target: { value: v },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    dirty.current = true

    void changeCriterion('value', v, index)
  }

  const handleKeyDown = (evt: React.KeyboardEvent<HTMLInputElement>): void => {
    // handle backspace on multi values: if "somethig, " and backspace => remove last empty element
    if (evt.key === 'Backspace') {
      const {
        currentTarget: { selectionStart: s, selectionEnd: e },
      } = evt

      if (s === e && s !== null && s > 0) {
        if (
          s === evt.currentTarget.value.length &&
          evt.currentTarget.value[s - 1].match(/\s/) != null
        ) {
          evt.preventDefault()

          const newValue = evt.currentTarget.value
            .split(',')
            .map((o) => o.trim())
            .slice(0, -1)
            .join(', ')

          void changeCriterion('value', newValue, index)
        } else if (item.value[s - 1].match(/[\s,]/) != null) {
          evt.preventDefault()
          evt.currentTarget.setSelectionRange(s - 1, s - 1)
        }
      }
    }

    if (evt.key === ',') {
      const newValue = evt.currentTarget.value
        .split(',')
        .map((o) => o.trim())
        .join(', ')

      void changeCriterion('value', newValue, index)
    }
  }

  const showFeedback = item.value.length === 0 && dirty.current

  return (
    <FormElement
      variant={showFeedback ? 'danger' : undefined}
      feedback={
        showFeedback
          ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
          : undefined
      }
      hint={intl.formatMessage({ id: 'Load.RecipientsList.InputValuesHint' })}
    >
      <InputText
        value={item.value}
        onChange={handleChange}
        variant={showFeedback ? INPUT_TEXT_VARIANT_DANGER : undefined}
        placeholder={intl.formatMessage({
          id: 'Load.RecipientsList.InputValuePlaceholder',
        })}
        onKeyUp={handleKeyDown}
      />
    </FormElement>
  )
}

export default InputValues
